interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  onReset?: () => void;
  resetLabel?: string;
  children?: React.ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  onReset,
  resetLabel = "重置筛选条件",
  children,
}: EmptyStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-background-300 bg-background-100 px-5 py-12 flex flex-col items-center text-center">
      <span className="w-14 h-14 rounded-full bg-background-200 text-foreground-500 flex items-center justify-center">
        <i className={`${icon} text-2xl`} />
      </span>
      <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{title}</h3>
      <p className="mt-1.5 text-[12.5px] text-foreground-600 max-w-sm leading-relaxed">{description}</p>
      {onReset ? (
        <button
          type="button"
          onClick={onReset}
          className="mt-4 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-[13px] hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1.5"
        >
          <i className="ri-refresh-line" />
          {resetLabel}
        </button>
      ) : null}
      {children}
    </div>
  );
}